import React from 'react';

export const Footer = () => (
  <footer className="w-full border-t border-white/10 bg-black/80 py-5 mt-16" data-testid="permanent-footer">
    <div className="max-w-7xl mx-auto px-6 text-center font-body text-[10px] sm:text-xs tracking-[0.2em] uppercase text-white/50">
      © 2026 GO OUTDOORS LLC<sup>TM</sup> &nbsp;|&nbsp; LEVERAGING AI FOR THE REST OF US<sup>TM</sup> &nbsp;|&nbsp; Public Landowner AI<sup>TM</sup>
    </div>
  </footer>
);

export default Footer;
